// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CustomerServiceOutlinedSvg from "@ant-design/icons-svg/es/asn/CustomerServiceOutlined";
import AntdIcon from '../components/AntdIcon';

var CustomerServiceOutlined = function CustomerServiceOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CustomerServiceOutlinedSvg
  }));
};

CustomerServiceOutlined.displayName = 'CustomerServiceOutlined';
export default React.forwardRef(CustomerServiceOutlined);